"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Once = void 0;
var Once = (function () {
    function Once() {
        this.listeners = new Set();
    }
    Once.prototype.add = function (listener) {
        this.listeners.add(listener);
    };
    Once.prototype.emit = function () {
        var copy = new Set(this.listeners);
        this.listeners.clear();
        copy.forEach(function (cb) {
            try {
                cb();
            }
            catch (error) {
                console.error(error);
            }
        });
    };
    return Once;
}());
exports.Once = Once;
//# sourceMappingURL=once.js.map